/**
 *  @fileOverview Scrollspy module, initalises scrollspy on side nav
 *
 *  @author       Chris Hill
 *
 */

function StickyfillModule (stickyfill, Utilities) {
  /**
   * @description Initialises stickyfill.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    var aside = document.querySelector('.aside')
    var header = document.querySelector('.header')

    if (header !== null) {
      stickyfill.addOne(header)
    }

    /**
     * Account for height of aside nav if it isn't sitting on the right hand side eg full screen
     */
    if (typeof aside !== 'undefined' && aside !== null) {
      if (aside.offsetLeft === 0) {
        stickyfill.addOne(aside)
      }
    }
  }
}

module.exports = StickyfillModule
